import(/* webpackMode: "eager", webpackExports: ["CookieManagerContext"] */ "/app/libs/environment/cookies-util/src/context/cookie-manager-context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/environment/cookies-util/src/context/cookie-manager-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/environment/environment-util/src/EnvsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/safety/safety-feature/src/components/Safety/Safety.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/shared/ui-helpers/src/components/JsonLd/JsonLd.tsx");
